module.exports = __webpack_public_path__ + "static/media/wain.50822a5c.png";